// extracted by mini-css-extract-plugin
export default {"Layer":"📚19-10-2_MzTS","ModalLayer":"📚19-10-2KtxAY","Translucent":"📚19-10-2XItK4","Transparent":"📚19-10-2PPufJ","disableScroll":"📚19-10-2Qb9Nw","Container":"📚19-10-2Am6mM"};